import { pb } from './pb';

export async function fetchCategories(kind){
  const list = await pb.collection('categories').getFullList({
    filter: `kind='${kind}'`,
    sort: 'order,name',
  });
  return list;
}

export async function createCategory(data){
  return pb.collection('categories').create(data);
}

export async function updateCategory(id, data){
  return pb.collection('categories').update(id, data);
}

export async function deleteCategory(id){
  return pb.collection('categories').delete(id);
}

export function buildCategoryTree(categories){
  const byId = new Map(categories.map(c => [c.id, {...c, children: []}]));
  const roots = [];
  for(const c of byId.values()){
    const parentId = c.parent;
    if(parentId && byId.has(parentId)){
      byId.get(parentId).children.push(c);
    }else{
      roots.push(c);
    }
  }
  return roots;
}
